// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import useStyles from './DialogManageSite.style';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import RefreshIcon from '@mui/icons-material/Replay';
import TextField from '@mui/material/TextField';
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';

const DialogSliderConfiguration = ({
    altTag,
    close,
    fullScreen,
    handleChangeSliderConfiguration,
    imgListTag,
    infoTag,
    nameTag,
    open,
    query,
    restoreDefaultSettings,
    robot,
    siteName,
    titleTag,
    url,
    urlTag
}) => {

    const classes = useStyles();

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={close}
            disableRestoreFocus={true}
            aria-labelledby='responsive-dialog-title'
            classes={{
                paper: classes.dialogPaper
            }}
        >
            <DialogTitle id='responsive-dialog-title' className={classes.dialogTitle}>{translate.i18n('ADD_SLIDER_CONFIG_FOR', { siteName })}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <FormControl
                    variant='outlined'
                    className={classes.textField}
                >
                    <InputLabel>{translate.i18n('BOT_VERSION')}</InputLabel>
                    <Select
                        label={translate.i18n('BOT_VERSION')}
                        value={robot}
                        onChange={event => handleChangeSliderConfiguration('robot', event.target.value)}
                    >
                        <MenuItem value={'NONE'}>None</MenuItem>
                        <MenuItem value={'V2'}>v2</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label={translate.i18n('URL')}
                    type='text'
                    value={url}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('url', event.target.value)}
                />
                <TextField
                    label={'Query'}
                    type='text'
                    value={query}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('query', event.target.value)}
                />
                <TextField
                    label={'Image list tag'}
                    type='text'
                    value={imgListTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('imgListTag', event.target.value)}
                />
                <TextField
                    label={'Info tag'}
                    type='text'
                    value={infoTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('infoTag', event.target.value)}
                />
                <TextField
                    label={'Name tag'}
                    type='text'
                    value={nameTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('nameTag', event.target.value)}
                />
                <TextField
                    label={'Url tag'}
                    type='text'
                    value={urlTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('urlTag', event.target.value)}
                />
                <TextField
                    label={'Title tag'}
                    type='text'
                    value={titleTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('titleTag', event.target.value)}
                />
                <TextField
                    label={'Alt tag'}
                    type='text'
                    value={altTag}
                    variant='outlined'
                    className={classes.textField}
                    onChange={event => handleChangeSliderConfiguration('altTag', event.target.value)}
                />
                <Button
                    className={classes.textField}
                    variant='outlined'
                    color='primary'
                    onClick={restoreDefaultSettings}>
                    {translate.i18n('DEFAULT_SETTINGS')}
                    <RefreshIcon className={classes.rightIcon} />
                </Button>
            </DialogContent>
            <DialogActions>
                <IconButton color='primary' onClick={close}>
                    <DoneIcon />
                </IconButton>
            </DialogActions>
        </Dialog>
    );
};

DialogSliderConfiguration.propTypes = {
    close: PropTypes.func,
    open: PropTypes.bool,
    altTag: PropTypes.string,
    imgListTag: PropTypes.string,
    infoTag: PropTypes.string,
    nameTag: PropTypes.string,
    query: PropTypes.string,
    titleTag: PropTypes.string,
    urlTag: PropTypes.string,
    url: PropTypes.string,
    robot: PropTypes.string,
    restoreDefaultSettings: PropTypes.func,
    siteName: PropTypes.string,
    fullScreen: PropTypes.bool,
    handleChangeSliderConfiguration: PropTypes.func
};

export default DialogSliderConfiguration;
